// extracted by mini-css-extract-plugin
export default {"item":"b5vT_","pointIcon":"tRDdx","pointInfo":"yHm3f","pointAddress":"fI_VP","head":"rdksW","arrow":"HNUiN","name":"zVK56","underline":"OplUn","truncated":"S2NdY"};